export const getParentUrlFromPath = (path?: string): string => {
  if (!path) return "";
  return path.split("/")[1];
};
